import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class LensesService {
  constructor(private http: HttpClient, ) {

  }

  lensesUrl = environment.links.clWizards.response;

  getLenses(_productCode: string, _values?: string[]) {
    let productCode: string = _productCode;
    return this.http.get(this.lensesUrl+productCode)

  }
}
